'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _RouterActions = require('../../../core/actions/RouterActions');

var _isNewSignupUx = require('../../../core/utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (next) {
  var stepNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return {
    route: _appStepRoutes2.default.JOIN_HUBSPOT_USER,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.UserRegistration, props)
      );
    },
    props: {
      handleSubmit: (0, _isNewSignupUx2.default)() ? _RouterActions.goToStep.bind(null, next) : _RouterActions.goToStep.bind(null, _appStepRoutes2.default.CREATE),
      nextStep: next
    },
    stepNumber: stepNumber
  };
};

module.exports = exports['default'];